import { ReactNode } from 'react';

export enum FileType {
  Image = 'IMAGE',
  File = 'FILE',
}

export enum FileUploadStatus {
  Loading = 'LOADING',
  Success = 'SUCCESS',
  Error = 'ERROR',
}

export type File = {
  type: FileType;
  name: string;
  url: string;
  size?: number;
  thumbnails?: {
    360: string;
  };
};

export type FileCardProps = {
  file?: File;
  className?: string;
  errorMessage?: string;
  isParticipation: boolean;
  status: FileUploadStatus;
  loadingProgress?: number;
  onClickClose?: (data: unknown) => void;
  onClickRetry?: (data: unknown) => void;
  onClickDownload?: (data: File) => void;
  onClickPreview?: (data: File) => void;
};

export type FileCardWrapperProps = {
  children: ReactNode;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onClick?: () => void;
  isParticipation: boolean;
};
